export function arrayToString(v) {
  return v.length > 0 ? v.join(',') : undefined;
}
